import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError, setFormatedResponse } from "../services/apiService";

/* Add Designation Service*/
const addDesignation = (params) => {
  const { axiosInstance, config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.admin.createDesignation}`,
    method: "POST",
    data: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

/* Get Designation Service*/
const getAllDesignation = (params) => {
  const { axiosInstance, config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.admin.getAllDesignation}`,
    method: "GET",
    params: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

/* Get Designations By Department */
const getDesignationsByDepartment = (params) => {
  const { axiosInstance, config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.admin.getDesignationsByDepartment}`,
    method: "GET",
    params: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};


/* Update Designation Service*/
const updateDesignation = (params) => {
  const { axiosInstance, config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.admin.updateDesignation}`,
    method: "PUT",
    data: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};


/* Delete Designation Service*/
const deleteDesignation = (params) => {
  const { axiosInstance, config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.admin.deleteDesignation}`,
    method: "DELETE",
    data: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

export default {
  addDesignation,
  getAllDesignation,
  updateDesignation,
  deleteDesignation,
  getDesignationsByDepartment
}